import { TasksStore } from "@components/modules/resource-planning/tasks/store";
import { TasksViewModeStore } from "@components/modules/resource-planning/tasks/store/view-mode";
import { TaskDetailModalStore } from "@components/widgets/Modals/ModalCommunication/store/task-detail-store";
import { BudgetsExportStore } from "@src/components/modules/budgets/export/Store";
import { BudgetovacPositionsSetModalStore } from "@src/components/modules/budgets/positions-sets/components/modal/store";
import { BudgetQuotesListingStore } from "@src/components/modules/budgets/quotes/store";
import { SendInvoiceModalStore } from "@src/components/modules/invoices/outgoing/listing/table/SendInvoice/Store";
import { NotificationsStore } from "@src/components/modules/notifications/listing/store";
import { ProjectCreateBudgetItemModalStore } from "@src/components/modules/projects/detail/create-budget-item-modal/store";
import { TasksKanbanStore } from "@src/components/modules/resource-planning/tasks/kanban/store";
import { TasksListingStore } from "@src/components/modules/resource-planning/tasks/listing/store";
import { ProjectCategoryModalStore } from "@src/components/ui-kit/ProjectCategorySelect/ModalStore";
import { ProjectCategorySelectStore } from "@src/components/ui-kit/ProjectCategorySelect/Store";
import { ManualPaymentModalStore } from "@src/components/widgets/manual-payment-modal/store";
import { MatchPaymentModalStore } from "@src/components/widgets/match-payment-modal/store";
import { activateI18n } from "@src/services/i18n";
import { AllocationModalStore } from "@src/stores/AllocationModalStore";
import { AuthStore } from "@src/stores/AuthStore";
import { ChangeTimeTrackingWorkTypeModalStore } from "@src/stores/ChangeTimeTrackingWorkTypeModalStore";
import { CompleteCapacityAllocationModalStore } from "@src/stores/CompleteCapacityAllocationModalStore";
import { CreateUserModalStore } from "@src/stores/CreateUserModalStore";
import { DeleteAllocationModalStore } from "@src/stores/DeleteAllocationModalStore";
import { EditUserModalStore } from "@src/stores/EditUserModalStore";
import { ModelLockStore } from "@src/stores/model-lock-store";
import { ProjectDetailForClientsStore } from "@src/stores/ProjectDetailForClientsStore";
import { ProjectListingForClientsStore } from "@src/stores/ProjectListingForClientsStore";
import { SettingsModalStore } from "@src/stores/SettingsModalStore";
import { SendQuoteModalStore } from "@src/stores/send-quote-modal";
import { StarStore } from "@src/stores/star-store";
import { TaskFormModalStore } from "@src/stores/TaskFormModalStore";
import { TimeTrackingPopoverStore } from "@src/stores/TimeTrackingPopoverStore";
import { TimeTrackingStore } from "@src/stores/TimeTrackingStore";
import { TrackedForDayModalStore } from "@src/stores/TrackedForDayModalStore";
import { TagStore } from "@src/stores/tag-store";
import { TagModalStore } from "@src/stores/tag-store/modal/store";
import { UIStore } from "@src/stores/UIStore/UIStore";
import { UserInvitationSentModalStore } from "@src/stores/UserInvitationSentModalStore";
import { WorkspaceStore } from "@src/stores/WorkspaceStore/WorkspaceStore";
import { createContext } from "react";
import { FilterTemplatesStore } from "./FilterTemplatesStore";
import { PipedriveStore } from "./pipedrive";
import { ResourcePlanningDayStore } from "./ResourcePlanningDayStore";
import { ResourcePlanningWeekStore } from "./ResourcePlanningWeekStore";
import { SelectWorkTypeIfUserNotInTaskModalStore } from "./SelectWorkTypeIfUserNotInTaskModaStore";

export class AppStore {
  authStore: AuthStore = new AuthStore(this);
  workspaceStore: WorkspaceStore = new WorkspaceStore(this);
  UIStore: UIStore = new UIStore(this);
  settingsModalStore = new SettingsModalStore(this);

  /**
   * Users
   */
  userInvitationSentModalStore: UserInvitationSentModalStore =
    new UserInvitationSentModalStore(this);
  editUserModalStore: EditUserModalStore = new EditUserModalStore(this);
  createUserModalStore: CreateUserModalStore = new CreateUserModalStore(this);

  /**
   * Time tracking
   */
  timeTrackingStore: TimeTrackingStore = new TimeTrackingStore(this);
  timeTrackingPopoverStore: TimeTrackingPopoverStore =
    new TimeTrackingPopoverStore(this);

  budgetsExportStore: BudgetsExportStore = new BudgetsExportStore(this);

  /**
   * Budgetovac Positions Sets
   */
  budgetovacPositionsSetModalStore: BudgetovacPositionsSetModalStore =
    new BudgetovacPositionsSetModalStore(this);

  /**
   * Quotes
   */
  budgetQuotesListingStore: BudgetQuotesListingStore =
    new BudgetQuotesListingStore(this);
  sendQuoteModalStore: SendQuoteModalStore = new SendQuoteModalStore(this);

  /**
   * Project management
   */
  taskFormModalStore: TaskFormModalStore = new TaskFormModalStore(this);
  tasksViewModeStore: TasksViewModeStore = new TasksViewModeStore(this);
  tasksListingStore: TasksListingStore = new TasksListingStore(this);
  tasksKanbanStore: TasksKanbanStore = new TasksKanbanStore(this);
  tasksStore: TasksStore = new TasksStore(this);
  // TODO: rename store file after Forecasting merge to avoid conflicts
  taskDetailModalStore: TaskDetailModalStore = new TaskDetailModalStore(this);
  projectCreateBudgetItemModalStore: ProjectCreateBudgetItemModalStore =
    new ProjectCreateBudgetItemModalStore(this);
  projectCategorySelectStore: ProjectCategorySelectStore =
    new ProjectCategorySelectStore(this);
  projectCategoryModalStore: ProjectCategoryModalStore =
    new ProjectCategoryModalStore(this);
  projectListingForClientsStore: ProjectListingForClientsStore =
    new ProjectListingForClientsStore(this);
  projectDetailForClientsStore: ProjectDetailForClientsStore =
    new ProjectDetailForClientsStore(this);

  /**
   * Resource planning
   */
  resourcePlanningDayStore: ResourcePlanningDayStore =
    new ResourcePlanningDayStore(this);
  resourcePlanningWeekStore: ResourcePlanningWeekStore =
    new ResourcePlanningWeekStore(this);
  allocationModalStore: AllocationModalStore = new AllocationModalStore(this);
  completeCapacityAllocationModalStore: CompleteCapacityAllocationModalStore =
    new CompleteCapacityAllocationModalStore(this);
  deleteAllocationModalStore: DeleteAllocationModalStore =
    new DeleteAllocationModalStore(this);
  trackedForDayModalStore: TrackedForDayModalStore =
    new TrackedForDayModalStore(this);
  changeTimeTrackingWorkTypeModalStore: ChangeTimeTrackingWorkTypeModalStore =
    new ChangeTimeTrackingWorkTypeModalStore(this);

  sendInvoiceModalStore: SendInvoiceModalStore = new SendInvoiceModalStore(
    this,
  );
  selectWorkTypeIfUserNoInTaskModalStore: SelectWorkTypeIfUserNotInTaskModalStore =
    new SelectWorkTypeIfUserNotInTaskModalStore(this);
  notificationsStore: NotificationsStore = new NotificationsStore(this);
  filterTemplatesStore: FilterTemplatesStore = new FilterTemplatesStore(this);
  manualPaymentModalStore: ManualPaymentModalStore =
    new ManualPaymentModalStore(this);
  matchPaymentModalStore: MatchPaymentModalStore = new MatchPaymentModalStore(
    this,
  );
  pipedriveStore = new PipedriveStore();

  /**
   * Tags
   */
  tagStore: TagStore = new TagStore(this);
  tagModalStore: TagModalStore = new TagModalStore(this);

  /**
   * ModelLocks
   */
  modelLock: ModelLockStore = new ModelLockStore(this);

  /**
   * Starring feature for tasks, projects, etc.
   */
  starStore: StarStore = new StarStore(this);
}

activateI18n("en");
export const appStore = new AppStore();

export const AppStoreContext = createContext<AppStore>(appStore);
